import { useNavigate } from 'react-router-dom';

import { snackbar } from '@occc-app/design-system';

import { RetailerNetworkCreatePage } from './retailer-network-create-page.component';

import { useRetailerNetworkCreateMutation } from '../../data-access/mutations';
import { RetailerNetworkConfigurationFormValues } from '../retailer-network-configuration/retailer-network-configuration.types';
import { RetailerNetworkConfigurationTabs } from '../retailer-connect.types';
import { routeCreator } from '../retailer-connect.utils';

export const RetailerNetworkCreatePageContainer = () => {
  // TODO: Query to see if customerId is already connected to a retailer network and redirect to the 'update network' flow?
  const navigate = useNavigate();

  const [retailerNetworkCreateMutation] = useRetailerNetworkCreateMutation({
    onCompleted: (data) => {
      snackbar.success('Retailer Network has been successfully created');
      navigate(routeCreator.configurationUpdateNetworkLocations(data.retailerNetworkCreate.uuid));
    },
  });

  const retailerNetworkCreate = async (values: RetailerNetworkConfigurationFormValues) => {
    await retailerNetworkCreateMutation({
      variables: {
        input: {
          ...values,
          address: {
            ...values.address,
            state: values.address.state.id,
          },
          customerId: values.customerId.id,
        },
      },
    });
  };

  return (
    <RetailerNetworkCreatePage
      tabValue={RetailerNetworkConfigurationTabs.Details}
      retailerNetworkCreate={retailerNetworkCreate}
    />
  );
};
